import { computed } from 'vue'

export function useOccasionHrefs(occasion, canonicalPaths, registerParams) {
  const infoHref = computed(() => {
    let href = ''
    switch (occasion.value?.product_variant?.product?.occasion_type?.code) {
      case 'C':
        href = `/training/courses/${occasion.value.product_variant.product.page_slug}`
        break
      case 'W':
        href = `/training/workshops/${occasion.value.product_variant.product.page_slug}`
        break
    }
    return href
  })
  const registerHref = computed(() => {
    if (infoHref.value && occasion.value) {
      const url = new URL(infoHref.value, canonicalPaths.base)
      url.hash = `h${occasion.value.sku}`
      if (Array.isArray(registerParams?.value))
        registerParams.value.forEach(([n, v]) => url.searchParams.set(n, v))
      return url.href
    }
    return ''
  })

  return {
    infoHref,
    registerHref
  }
}
